module.exports = __webpack_public_path__ + "img/secondary-3.4ef022af.svg";